module.exports = __webpack_public_path__ + "img/img9.67a83608.png";